module.exports = __webpack_public_path__ + "media/images/new-ui-images/task-7eca830104d7d40d1d1fc016de7e058c.svg";